module.exports = __webpack_public_path__ + "img/CM-SS-25-Mazda-Playful.fa844b43.jpg";